import { makeFilterString } from "services/modules/utils/Helper";
import {
  GetEmployeesSuccess,
  EmployeesLoading,
  GetEmployeeDetailsSuccess,
  AddEmployeeSuccess,
  UpdateEmployeeSuccess,
  DeleteEmployeeSuccess,
} from "./Action";

import { reduxRequest } from "common/utils/reduxRequest";

export const getEmployeesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EmployeesLoading,
    loadingType: "list",
    successFunction: GetEmployeesSuccess,
    url: `/employees${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const addEmployeeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EmployeesLoading,
    loadingType: "add",
    successFunction: AddEmployeeSuccess,
    action: variables?.action,
    url: `/employees`,
    method: "post",
    data: variables?.body,
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getEmployeeDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EmployeesLoading,
    loadingType: "details",
    successFunction: GetEmployeeDetailsSuccess,
    action: variables?.action,
    url: `/employees/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateEmployeeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EmployeesLoading,
    loadingType: "update",
    successFunction: UpdateEmployeeSuccess,
    action: variables?.action,
    url: `/employees/${variables?.id}`,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteEmployeeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EmployeesLoading,
    loadingType: "delete",
    successFunction: DeleteEmployeeSuccess,
    action: variables?.action,
    url: `/employees/${variables?.id}`,
    method: "delete",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
